(() => {
  if (customElements.get('press-slider')) {
    return;
  }

  class PressSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.spacing = Number(this.dataset.spacing) || 17;
    }

    connectedCallback() {
      this.initSlider();
    }

    updateFirstSlideClass() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      // Remove the class from all slides
      const allSlides = sliderElement.querySelectorAll('.swiper-slide');
      allSlides.forEach((slide) => {
        slide.classList.remove('swiper-slide-first');
      });

      // Find the slide with swiper-slide-prev class
      const prevSlide = sliderElement.querySelector('.swiper-slide-prev');
      if (prevSlide) {
        // Find the previous sibling slide
        const firstSlide = prevSlide.previousElementSibling;
        if (firstSlide && firstSlide.classList.contains('swiper-slide')) {
          firstSlide.classList.add('swiper-slide-first');
        }
      }
    }

    initSlider() {
      const sliderElement = this.querySelector('[data-slider]');
      if (!sliderElement) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: this.spacing,
        loop: true,
        speed: 500,
        centeredSlides: true,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        on: {
          init: () => {
            this.updateFirstSlideClass();
          },
          slideChange: () => {
            this.updateFirstSlideClass();
          },
          slideChangeTransitionStart: () => {
            this.updateFirstSlideClass();
          },
          slideChangeTransitionEnd: () => {
            this.updateFirstSlideClass();
          },
        },
      };

      this.slider = new Swiper(sliderElement, this.options);
    }
  }

  customElements.define('press-slider', PressSlider);
})();

